// extracted by mini-css-extract-plugin
export default {"emptyCartContainer":"EmptyCart_emptyCartContainer__5YwiU","boxImage":"EmptyCart_boxImage__DnQe3"};